/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Save/recall viewport</h4>

<p>
    Save or recall a viewport. To save the current viewport, click on the icon, then enter a name for the viewport and hit "Save".
    To recall a saved viewport simply click on it. To delete saved viewports click on the little "X" next to their name.
</p>`;

export default function SaveViewpointTooltip() {
    return h('div', { innerHTML: body });
}
